export default __webpack_public_path__ + "static/media/banner.c4233382.png";